import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import ApplicantCardAddSvg from '@src/svgs/applicant-card-add.svg';
import { PlaceholderProps } from './props';
import './styles.scss';

export const Placeholder: FC<PlaceholderProps> = ({ wrapperClassName, message, onClick }) => {
  return (
    <div
      className={classnames(
        'opening-applicant-card-placeholder',
        message && 'opening-applicant-card-placeholder--with-content',
        wrapperClassName,
      )}
      onClick={() => message && onClick?.()}
    >
      {!!message && (
        <div className="opening-applicant-card-placeholder__content">
          <Svg src={ApplicantCardAddSvg} />

          <div className="opening-applicant-card-placeholder__content-message">{message}</div>
        </div>
      )}
    </div>
  );
};
